// extracted by mini-css-extract-plugin
export var chip = "_3r-0";
export var filterDropdown = "_3r-5";
export var filterItem = "_3r-6";
export var icon = "_3r-1";
export var removeButton = "_3r-3";
export var removeIcon = "_3r-4";
export var separator = "_3r-2";